module.exports = __webpack_public_path__ + "static/media/quiz-checkmark-light.0d36318a.png";